var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTumblr(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 512,
    height: 512,
    viewBox: "0 0 512 512",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "",
    stroke: "none",
    fill: "#080404",
    fillRule: "evenodd"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M 212.280 37.020 C 211.012 37.530, 209.808 39.112, 209.474 40.707 C 206.108 56.749, 201.940 68.232, 193.348 85.141 C 182.120 107.236, 166.281 127.568, 151.713 138.585 C 148.296 141.169, 141.225 145.279, 136 147.719 C 130.775 150.158, 125.375 152.699, 124 153.365 L 121.500 154.576 121.236 185.788 L 120.972 217 145.306 217 L 169.640 217 169.187 308.827 L 168.735 400.653 171.065 408.501 C 178.229 432.632, 206.336 457.500, 237.529 467.304 C 280.103 480.686, 333.848 476.744, 379.278 456.910 C 384.350 454.695, 389.063 452.149, 389.750 451.250 C 391.568 448.876, 391.568 382.544, 389.750 383.320 C 389.063 383.613, 382.425 386.630, 375 390.024 C 356.874 398.309, 346.432 401.654, 334.649 402.949 C 308.551 405.817, 285.632 396.581, 276.749 379.616 C 273.819 374.020, 273.410 360.048, 273.844 280.250 L 274.187 217 325.594 217 L 377 217 377 182 L 377 147 325 147 L 273 147 273 92.535 C 273 39.711, 272.942 38.039, 271.066 37.035 C 268.665 35.750, 215.470 35.737, 212.280 37.020",
    stroke: "none",
    fill: "#040404",
    fillRule: "evenodd"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTumblr);
export default __webpack_public_path__ + "static/media/tumblr.4da17fe957ce7c20b735e93700b9e5b9.svg";
export { ForwardRef as ReactComponent };